define("shared/utils/delete-media-item", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class MediaItems
   * @extends Utils
   */

  /**
   * Takes a media item, performs any pre-delete processing, and then destroys the record
   *
   * @method deleteMediaItem
   * @param {MediaItem} mediaItem
   * @public
   *
   * @returns {Promise}
   */
  const deleteMediaItem = mediaItem => {
    _decrementLabelCounts(mediaItem);
    return mediaItem.destroyRecord();
  };

  /**
   * Decrements the `taggedCount` of each label associated with a media item,
   * in anticipation of media item deletion.
   *
   * @method _decrementLabelCounts
   * @param {MediaItem} mediaItem
   * @private
   *
   * @returns {void} modifies the mediaItem
   */
  const _decrementLabelCounts = mediaItem => {
    if (mediaItem.labels) {
      mediaItem.labels.forEach(label => {
        if (label.taggedCount > 0) {
          label.set('taggedCount', label.taggedCount - 1);
        }
      });
    }
  };
  var _default = _exports.default = deleteMediaItem;
});